import { useTheme } from "@/contexts/ThemeContext";
import { Toaster as Sonner, type ToasterProps } from "sonner";

/** Toasts use the site's own theme tokens (not next-themes, which this app doesn't mount), with a solid surface,
 * strong text and a coloured left edge per type, so a finished-work notice reads as calm confirmation and meets contrast
 * in both light and dark mode. */
const Toaster = ({ ...props }: ToasterProps) => {
  const { theme } = useTheme();

  return (
    <Sonner
      theme={theme === "dark" ? "dark" : "light"}
      className="toaster group"
      position="top-center"
      mobileOffset={{ top: 64 }}
      toastOptions={{
        classNames: {
          toast: "!bg-[var(--panel)] !text-[var(--paper)] !border !border-[var(--hairline)] !shadow-lg !border-l-4",
          title: "!text-[var(--paper)] !font-medium",
          description: "!text-[var(--fog)]",
          success: "!border-l-[var(--signal)]",
          error: "!border-l-[var(--bloom)]",
          warning: "!border-l-[var(--ember)]",
          info: "!border-l-[var(--pulse)]",
          closeButton: "!bg-[var(--panel-2)] !text-[var(--paper)] !border-[var(--hairline)]",
          actionButton: "!bg-[var(--signal)] !text-[var(--signal-foreground)]",
          cancelButton: "!bg-[var(--panel-2)] !text-[var(--paper)]",
        },
      }}
      style={
        {
          "--normal-bg": "var(--panel)",
          "--normal-text": "var(--paper)",
          "--normal-border": "var(--hairline)",
          "--success-bg": "var(--panel)",
          "--success-text": "var(--paper)",
          "--success-border": "var(--hairline)",
          "--error-bg": "var(--panel)",
          "--error-text": "var(--paper)",
          "--error-border": "var(--hairline)",
          "--info-bg": "var(--panel)",
          "--info-text": "var(--paper)",
          "--info-border": "var(--hairline)",
          "--warning-bg": "var(--panel)",
          "--warning-text": "var(--paper)",
          "--warning-border": "var(--hairline)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
